

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 21 21","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, rest), ["\n    ", h('g', {"id":"svg-recording-play-circle-WVa6d7V","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}, ["\n        ", h('g', {"id":"svg-recording-play-circle-25zSPpn","transform":"translate(-158.000000, -483.000000)","fill":"currentColor"}, ["\n            ", h('path', {"d":"M168.5,483 C174.29899,483 179,487.70101 179,493.5 C179,499.29899 174.29899,504 168.5,504 C162.70101,504 158,499.29899 158,493.5 C158,487.70101 162.70101,483 168.5,483 Z M167.1875,487.931534 L167.1875,499.068466 L172.755966,493.5 L167.1875,487.931534 Z","id":"svg-recording-play-circle-vkR-jmz"}, []), "\n        "]), "\n    "]), "\n"]);
};

        